// extracted by mini-css-extract-plugin
export var container = "_j1-0";
export var segment = "_j1-2";
export var segmentActive = "_j1-3";
export var track = "_j1-1";